import axios from 'axios';

import { getAdapter } from '@zyf2e/adapt';

getAdapter().isLogin = function() {
  return !!localStorage.getItem('token')
}

axios.defaults.headers.common.token = localStorage.getItem('token') || '';

export const getToken = () => {
  return window.localStorage.getItem('token') || ''
}

export const setToken = (token) => {
  window.localStorage.setItem('token', token || '')
  window.parent.postMessage({ type: 'setToken', payload: token })
  axios.defaults.headers.common.token = localStorage.getItem('token') || '';
  return token;
}
